import { VIDEO_MIME_TYPES } from '@crehana/player';

const trailerTypeToMimeType = (videoSourceType: string) =>
  videoSourceType.toUpperCase().includes('HLS')
    ? VIDEO_MIME_TYPES.HLS
    : VIDEO_MIME_TYPES.MP4;

export default trailerTypeToMimeType;
